import { render } from "./CookiesModal.vue?vue&type=template&id=36a3f5be&scoped=true&ts=true"
import script from "./CookiesModal.vue?vue&type=script&lang=ts"
export * from "./CookiesModal.vue?vue&type=script&lang=ts"

import "./CookiesModal.vue?vue&type=style&index=0&id=36a3f5be&scoped=true&lang=css"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a3f5be"]])

export default __exports__